import { apiClient } from '../lib/api-client';
import type {
  VerifyResponse,
  PartnerSearchResponse,
  PartnerBusinessDetail,
  PartnerTrainerDetail,
  SearchParams,
} from '../types';

export const partnerApi = {
  async verify(): Promise<VerifyResponse> {
    const { data } = await apiClient.get<VerifyResponse>('/verify');
    return data;
  },

  async search(params: SearchParams): Promise<PartnerSearchResponse> {
    const { data } = await apiClient.get<PartnerSearchResponse>('/search', {
      params: {
        query: params.query,
        type: params.type || 'all',
        city: params.city || undefined,
        limit: params.limit || 20,
        offset: params.offset || 0,
      },
    });
    return data;
  },

  async getBusiness(id: string): Promise<PartnerBusinessDetail> {
    const { data } = await apiClient.get<PartnerBusinessDetail>(`/business/${id}`);
    return data;
  },

  async getTrainer(id: string): Promise<PartnerTrainerDetail> {
    const { data } = await apiClient.get<PartnerTrainerDetail>(`/trainer/${id}`);
    return data;
  },
};
